module.exports = __webpack_public_path__ + "static/media/logo-gaiteiros.825c4506.png";